import { useEffect } from "react";

const SITE_TITLE = "Her Salty Studio – Crafted by hand. Kept forever.";

/** Sets the browser tab title for a page; restores the site title on unmount. */
export default function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} · Her Salty Studio` : SITE_TITLE;
    return () => {
      document.title = SITE_TITLE;
    };
  }, [title]);
}
